import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import ProposalMergeFields from "../../../MergeFields.jsx";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import { injectIntl } from "react-intl"

class TitleContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            isDummy: this.props.isDummy === true,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function(){},
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy === true,
            id: nextProps.id || '',
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className={"col-12"}>
                    <h2 style={{color: this.state.variables.global.secondaryColor}}>
                        {ProposalMergeFields.merge(this.state.section.attributes.content.title, this.state.variables, this.state.isDummy, this.props.intl)}
                    </h2>
                </div>
            </SectionWrapper>
        );
    }
}

export default injectIntl(TitleContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/title/section.component.jsx